<template>
  <td>
    <div>
      <button
        class="btn btn-primary"
        @click="showModal"
        v-html="displayValue"
      ></button>
      <component
        :show.sync="show"
        :is="attribute.modal"
        v-bind="model"
      ></component>
    </div>
  </td>
</template>

<script lang="babel">
import RedeemedCouponCustomersModal from "@/components/modals/RedeemedCouponCustomersModal";
import AffiliateRevenueModal from "@/components/modals/AffiliateRevenueModal";
import AffiliateUserRevenueModal from "@/components/modals/AffiliateUserRevenueModal";
import EMailLogModal from "@/components/modals/EMailLogModal";
import PublicAffiliateParametersModal from "@/components/modals/PublicAffiliateParametersModal";

export default {
  components: {
    RedeemedCouponCustomersModal,
    AffiliateRevenueModal,
    EMailLogModal,
    AffiliateUserRevenueModal,
    PublicAffiliateParametersModal
  },
  props: ['content', 'label', 'model', 'attribute'],
  data() {
    return {
      show: false,
      formatter: false
    };
  },
  methods: {
    showModal() {
      this.show = true;
    }
  },
  created() {
    this.formatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    });
  },
  computed: {
    displayValue() {
      switch (this.attribute.mode) {
        case 'currency':
          return this.formatter.format(this.content);

        case 'userCurrency':
          return '<i class="fas fa-user"></i> | ' + this.formatter.format(this.content);

        case 'emailLog':
          return 'Nachricht öffnen';

        case 'additionalParameters':
          return 'Parameter anzeigen';

        default:
          return this.content;
      }
    }
  }
};
</script>
